import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// console.log("Main.js");
// console.log(environment);

if (environment.production) {
  enableProdMode();
}
//
// Disable the console.log in UAT and Production environment.
//
// if (!environment.enableConsole) {
//   if (window) {
//     window.console.log = function() {};
//   }
// }

/** Don't change this codes to be following:
 *  const platform = platformBrowserDynamic(); platform.bootstrapModule(AppModule).catch(err => console.log(err)); 
 *  (this line of code came from Kendo UI web site sample codes)
 *  Since above lien of code will trigger when running command "ng serve -aot"
 *  browser raised exception "No NgModule metadata found for 'function (){}"
 *
*/
platformBrowserDynamic().bootstrapModule(AppModule).catch(err => console.log(err));

